import { TANK_CONFIG } from "../config";

//TODO: implement TANK_CONFIG_BASIC?

export interface TankModelConfig {
  id: string;
  name: string;
  dimensions: {
    body: { width: number; height: number; length: number };
    turret: { radius: number; height: number };
    barrel: { radius: number; length: number };
    tracks: { width: number; height: number; length: number };
  };
  colors: {
    body: number;
    turret: number;
    barrel: number;
    tracks: number;
  };
  stats: {
    maxSpeed: number;
    maxSpeedKMH: number;
    speedFactor: number;
    acceleration: number;
    turnSpeed: number;
    health: number;
    armor: number;
  };
  projectilesConfig: {
    SPEED: number;
    RANGE: number;
    SIZE: number;
    TRAIL_LENGTH: number;
    TYPE: string;
  };
}

export const TANK_MODELS: { [key: string]: TankModelConfig } = {
  standard: {
    id: "standard",
    name: "Standard Tank",
    dimensions: {
      body: { width: 2, height: 1, length: 3 },
      turret: { radius: 0.8, height: 0.5 },
      barrel: { radius: 0.1, length: 3.5 },
      tracks: { width: 0.4, height: 0.4, length: 3.2 },
    },
    colors: {
      body: 0x5d7f38,
      turret: 0x4a6631,
      barrel: 0x333333,
      tracks: 0x222222,
    },
    stats: {
      maxSpeed: TANK_CONFIG.MOVEMENT.MAX_SPEED,
      maxSpeedKMH: TANK_CONFIG.MOVEMENT.MAX_SPEED_KMH,
      speedFactor: TANK_CONFIG.MOVEMENT.SPEED_FACTOR, //Współczynnik konwersji prędkości na km/h - dostosowany (70/0.8 = 87.5)
      acceleration: TANK_CONFIG.MOVEMENT.ACCELERATION,
      turnSpeed: TANK_CONFIG.MOVEMENT.TURN_SPEED,
      health: TANK_CONFIG.HEALTH.MAX_HEALTH,
      armor: TANK_CONFIG.HEALTH.ARMOR,
    },
    projectilesConfig: {
      SPEED: 1.0, // Prędkość pocisku
      RANGE: 50, // Zasięg pocisku
      SIZE: 0.1, // Rozmiar pocisku
      TRAIL_LENGTH: 10, // Długość śladu pocisku
      TYPE: "standard",
    },
  },
  // light
  light: {
    id: "light",
    name: "Light Tank",
    dimensions: {
      body: { width: 2, height: 0.7, length: 2.5 },
      turret: { radius: 0.7, height: 0.4 },
      barrel: { radius: 0.08, length: 4.2 },
      tracks: { width: 0.25, height: 0.25, length: 2.5 },
    },
    colors: {
      body: 0x6b8e23,
      turret: 0x556b2f,
      barrel: 0x333333,
      tracks: 0x222222,
    },
    stats: {
      maxSpeed: TANK_CONFIG.MOVEMENT.MAX_SPEED * 1.5,
      maxSpeedKMH: TANK_CONFIG.MOVEMENT.MAX_SPEED_KMH * 1.5,
      speedFactor: TANK_CONFIG.MOVEMENT.SPEED_FACTOR, //Współczynnik konwersji prędkości na km/h - dostosowany (70/0.8 = 87.5)
      acceleration: TANK_CONFIG.MOVEMENT.ACCELERATION * 1.4,
      turnSpeed: TANK_CONFIG.MOVEMENT.TURN_SPEED * 1.4,
      health: TANK_CONFIG.HEALTH.MAX_HEALTH * 0.8,
      armor: TANK_CONFIG.HEALTH.ARMOR * 0.5,
    },
    projectilesConfig: {
      SPEED: 1.0, // Prędkość pocisku
      RANGE: 50, // Zasięg pocisku
      SIZE: 0.1, // Rozmiar pocisku
      TRAIL_LENGTH: 10, // Długość śladu pocisku
      TYPE: "bolt",
    },
  },
  heavy: {
    id: "heavy",
    name: "Heavy Tank",
    dimensions: {
      body: { width: 2.5, height: 1.1, length: 3.5 },
      turret: { radius: 0.9, height: 0.6 },
      barrel: { radius: 0.12, length: 3.8 },
      tracks: { width: 0.45, height: 0.45, length: 3.4 },
    },
    colors: {
      body: 0x4a5d32,
      turret: 0x3d4d29,
      barrel: 0x333333,
      tracks: 0x222222,
    },
    stats: {
      maxSpeed: TANK_CONFIG.MOVEMENT.MAX_SPEED * 0.7,
      maxSpeedKMH: TANK_CONFIG.MOVEMENT.MAX_SPEED_KMH * 0.7,
      speedFactor: TANK_CONFIG.MOVEMENT.SPEED_FACTOR, //Współczynnik konwersji prędkości na km/h - dostosowany (70/0.8 = 87.5)
      acceleration: TANK_CONFIG.MOVEMENT.ACCELERATION * 0.6,
      turnSpeed: TANK_CONFIG.MOVEMENT.TURN_SPEED * 0.6,
      health: TANK_CONFIG.HEALTH.MAX_HEALTH * 1.4,
      armor: TANK_CONFIG.HEALTH.ARMOR * 1.5,
    },
    projectilesConfig: {
      SPEED: 1.0, // Prędkość pocisku
      RANGE: 50, // Zasięg pocisku
      SIZE: 0.1, // Rozmiar pocisku
      TRAIL_LENGTH: 10, // Długość śladu pocisku
      TYPE: "laser",
    },
  },
};
